module.exports = __webpack_public_path__ + "d7655f3ac843d3e56e253bf8766c05df.pdf";